import { Component, Input } from '@angular/core';

import { statusProjetadoProjetado } from '../../cliente-analise-mercado-status-projetado';
import { ClienteAnaliseMercadoStatusProjetadoPipe } from '../../pipes';

@Component({
    selector: 'sgt-cliente-analise-mercado-status-projetado-badge-pill-projetado',
    templateUrl: './cliente-analise-mercado-status-projetado-badge-pill-projetado.component.html',
    styleUrls: ['./cliente-analise-mercado-status-projetado-badge-pill-projetado.component.less']
})
export class ClienteAnaliseMercadoStatusProjetadoBadgePillProjetadoComponent {
    /** Title para exibir no badge */
    @Input() title: string = null;

    constructor(private clienteAnaliseMercadoStatusProjetadoPipe: ClienteAnaliseMercadoStatusProjetadoPipe) { }

    /** Retorna o title para exibir no badge */
    getTitle(): string {
        return this.title ? this.title : this.clienteAnaliseMercadoStatusProjetadoPipe.transform(statusProjetadoProjetado.id);
    }
}
